module.exports = __webpack_public_path__ + "img/fa-arrow-right.48ad2720.svg";